import { IsEmail } from 'class-validator';
import { BaseModel } from '../base-model';

export class ForgetPasswordModel implements BaseModel {
    @IsEmail(undefined, { message: 'Email is not valid' })
    public Email: string = '';

    public beforeValidation() {}
}
